<template>
  <div  v-if="post">

    
    <div class="row pa-5">
      <!-- Blog Content Area -->
      <div class="col-md-9">
<div class="card shadow-sm blog-card w-100">

        <div class="text-center mb-4">
          <img
            :src="post.image_path"
            alt="Blog Banner"
            class="img-fluid rounded blog-banner mb-3"
          />
          <h3 class="blog-title">{{ post.title }}</h3>
          <p class="text-muted blog-date">Published: {{ formatDate(post.current_date) }}</p>

          <div class="blog-categories">
            <span
              v-for="(cat, index) in post.categories.split(',')"
              :key="index"
              class="badge bg-primary me-2"
            >
              {{ cat.trim() }}
            </span>
          </div>

<!-- <div class="blog-categories mt-2" v-if="post?.keywords">
            <span
              v-for="(key, index) in post.keywords.split(',')"
              :key="index"
              class="badge bg-primary me-2"
            >
              {{ key.trim() }}
            </span>
          </div> -->
          <h6 class="mt-1">{{ post.snippet }}</h6>

        </div>

        <!-- Structured Content Blocks -->
        <div class="blog-content1 px-3 py-4">
          <div v-for="(block, index) in parsedBlocks" :key="index">
            <div v-if="block.type === 'paragraph'" class="mb-3" style="font-size: 15px;">{{ block.content }}</div>
              <component
    v-else-if="block.type === 'heading'"
    :is="block.level"
    class="my-3 font-weight-bold"
    style="font-size: 25px;"
    v-html="block.content"
  ></component>
            <div v-else-if="block.type === 'image'" class="text-center my-4">
              <img :src="block.src" alt="" class="img-fluid rounded" style="max-height: 400px" />
            </div>
            <div v-else-if="block.type === 'pdf'" class="my-4">
              <object
                :data="block.src"
                type="application/pdf"
                style="width: 100%; height: 600px"
                aria-label="PDF Preview"
              ></object>
            </div>
          </div>
        </div>

        <!-- Back Button -->
        <div class="text-center mt-5 mb-3">
          <router-link to="/blog" class="btn btn-secondary">
            ← Back to Blog Home
          </router-link>
        </div>
</div>

      </div>

      <!-- Recent Posts Sidebar -->
      <div class="col-md-3">


        <div class="card p-3">
          <h5 class="recent-title mb-3">Recent Posts</h5>
          <ul class="list-unstyled recent-list">
            <li
              v-for="item in recentPosts"
              :key="item.id"
              class="mb-2 border-bottom pb-2 text-truncate"
            >
              <router-link :to="`/blog/post/${item.slug}`" class="text-dark text-decoration-none" 
              style="color: #f07626 !important;font-size: 15px;">
                {{ item.title }}
              </router-link>
            </li>
          </ul>
        </div>
 <div class="card p-3 mt-3">
          <h5 class="recent-title mb-3">Categories</h5>
          <ul class="list-unstyled recent-list">
            <li
              v-for=" (value,index) of categrioesData" :key="index"
             
              class="mb-2 border-bottom pb-2"
            >
              <div
                @click="this.$router.push(`/blog/${value}`)"
              style="color: #f07626 !important;font-size: 15px;cursor: pointer;">
                 {{ value }}
          </div>
            </li>
          </ul>
        </div>



      </div>
    </div>



  </div>

  <div v-else class="text-center my-5">
    <p>Loading post...</p>
  </div>
</template>

<script>
import axios from 'axios'
import { getConfigDataFromLocalStorage } from "@/localStorageData/localStorageUtil.js";
export default {
  name: 'BlogDetail',
  data() {
    return {
      post: null,
      parsedBlocks: [],
      recentPosts: [],
      randomImage: null,
      blockFind_api:"",
      blockList_api:"",
blogCategories:"",
categrioesData:[],
    }
  },
  methods: {
    getConfig() {
      const getConfigData1 = getConfigDataFromLocalStorage();

      if (getConfigData1) {  
        this.blockList_api = getConfigData1.payload.portal_configuration.API_endpoints.blog_find
        this.blockFind_api = getConfigData1.payload.portal_configuration.API_endpoints.blog_get
       this.blockSlug_api = getConfigData1.payload.portal_configuration.API_endpoints. blog_post_slug
 this.blogCategories=getConfigData1.payload.portal_configuration.API_endpoints.blog_get_categories
       

      }
    },
     async getCategories(){

  try{
    const responce=await axios.get(this.blogCategories)
    console.log(responce,"this.blogCategories")
this.categrioesData=[]
    if(responce?.data?.categories){
      Object.values(responce.data.categories).forEach((obj)=>{
        this.categrioesData.push(obj)
      })
    }
    
  }
  catch (error) {
        console.error('Error fetching posts:', error)
      }


},
    async fetchPost() {
      const id = this.$route.params.id
      let get_api=""
      if (typeof id === 'number') {
  
 get_api=`${this.blockList_api}${id}`

} else if (typeof id === 'string') {
get_api=`${this.blockSlug_api}/${id}`
console.log(get_api,'get_api')
}
      try {
        const res = await axios.get(get_api)
        console.log(res,'res333')
        this.post = res.data.postData || null
       
        this.parseContent()
      } catch (err) {
        console.error('Post not found', err)
      }
    },
    async fetchRecent() {
      try {
        const res = await axios.get(this.blockFind_api)
        this.recentPosts = res.data.news_letter.slice(0, 5)
      } catch (err) {
        console.error('Recent posts error', err)
      }
    },
   parseContent() {
  if (!this.post || !this.post.content) return;

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = this.post.content;
  const children = tempDiv.children;
  const blocks = [];

  for (const el of children) {
    const tag = el.tagName.toLowerCase();

    if (tag === 'p') {
      blocks.push({ type: 'paragraph', content: el.textContent.trim() });
      
    } 
    else if (['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(tag)) {
      blocks.push({ type: 'heading', level: tag, content: el.innerHTML });
    } 
    else if (tag === 'img' || el.querySelector('img')) {
      const img = el.tagName === 'IMG' ? el : el.querySelector('img');
      if (img && img.src) {
        blocks.push({ type: 'image', src: img.src });
      }
    } 
    else if (tag === 'object' || el.querySelector('object')) {
      const pdf = el.tagName === 'OBJECT' ? el : el.querySelector('object');
      if (pdf && pdf.getAttribute('data')) {
        blocks.push({ type: 'pdf', src: pdf.getAttribute('data') });
      }
    }
  }

  this.parsedBlocks = blocks;
},

    formatDate(dateStr) {
      const date = new Date(dateStr)
      return date.toLocaleDateString('en-GB', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    }
  },
  mounted() {
    this.getConfig()
    this.fetchPost()
    this.fetchRecent()
    this.getCategories()
  }
}
</script>

<style scoped>
.blog-banner {
  max-height: 400px;
  object-fit: cover;
  width: 100%;
}
.blog-title {
  /* font-size: 2rem; */
  font-weight: 700;
  color: #1a2f70;
}
.blog-date {
  font-size: 0.9rem;
  margin-bottom: 10px;
}
.blog-categories .badge {
  font-size: 0.75rem;
  background-color: #d3262a;
}
.blog-content1 {
  background-color: #fdfdfd;
  /* border-radius: 10px; */
  padding: 24px;
  border: 1px solid #ddd;
  line-height: 1.8;
}
.blog-content1 table {
  width: 100%;
  margin-top: 1rem;
  border-collapse: collapse;
  border: 1px solid #ccc;
}
.blog-content1 th,
.blog-content1 td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: center;
}
.blog-content1 th {
  background-color: #eaf3fc;
  font-weight: bold;
}
.btn-secondary {
  background-color: #F07626;
  border: none;
  padding: 8px 16px;
  font-weight: 500;
  color: #fff;
  transition: 0.3s ease;
}
.btn-secondary:hover {
  background-color: #F07626;
}
.recent-title {
  color: #000;
  font-weight: 600;
}
.recent-list li {
  font-size: 14px;
  line-height: 1.6;
}
.recent-list a:visited{
    color:black !important;
}
</style>
